import { render } from "./AllProduct.vue?vue&type=template&id=4d70c013&scoped=true"
import script from "./AllProduct.vue?vue&type=script&lang=js"
export * from "./AllProduct.vue?vue&type=script&lang=js"

import "./AllProduct.vue?vue&type=style&index=0&id=4d70c013&scoped=true&lang=css"

import exportComponent from "/usr/src/app/ziohome_ver3_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d70c013"]])

export default __exports__